import {
  Box,
  Table,
  TableBody,
  TableHead,
  TableRow,
  Tooltip,
  Typography,
} from "@mui/material";
import makeStyles from "@mui/styles/makeStyles";
import StyledTableCell from "../../Tables/StyledTableCell";
import StyledTableRow from "../../Tables/StyledTableRow";
import TableActions from "./TableActions";
import Note from "../Note";
import { useEffect, useState } from "react";
import { institutionSelector } from "../../../../../store/researchauthoritiesSlice";
import { useSelector } from "react-redux";
import { PRE_PROPOSAL_STATUS } from "../../../Constants";

const useStyles = makeStyles((theme) => ({
  table: {
    width: "100%",
  },
  // listItem: {
  //   height: 60,
  // },
}));

export default function ApplicationsTable(props) {
  const classes = useStyles();
  const institution = useSelector(institutionSelector);
  const {
    applications,
    tableType,
    createPDF,
    updateProposalStatus,
    updateApplicantionNote,
  } = props;
  const [proposals, setProposals] = useState([]);
  const tableHeaders =
    tableType === "submit"
      ? [
          { label: "Applications title & no.", width: "20%" },
          { label: "Researchers", width: "20%" },
          { label: "Date submitted", width: "15%" },
          { label: "Status", width: "20%" },
          { label: "Stage", width: "10%" },
          { label: "Actions", width: "20%" },
          { label: "Notes", width: "5%" },
        ]
      : [
          { label: "Applications title & no.", width: "25%" },
          { label: "Researchers", width: "25%" },
          // { label: "Institute", width: "30%" },
          // { label: "Email", width: "15%" },
          { label: "Date submitted", width: "20%" },
          { label: "Stage", width: "10%" },
          { label: "Actions", width: "25%" },
          { label: "Notes", width: "5%" },
        ];

  const showDate = (shortDateString) => {
    shortDateString = shortDateString.slice(0, shortDateString.indexOf("T"));
    let date = new Date(shortDateString);
    let dateDisplay = date.toLocaleDateString("en-GB");
    return dateDisplay;
  };

  const getApplicantStatus = (status) => {
    switch (status) {
      case 100000000:
        return "Approved By RA";
      case 100000001:
        return "Approved By GIF";
      default:
        return "";
    }
  };

  useEffect(() => {
    applications.forEach((applicantion) => {
      const leader = applicantion.applicants.find(
        (applicant) => applicant.applicantId === applicantion.leaderId
      );
      if (leader.institutionId.toUpperCase() === institution.id.toUpperCase()) {
        applicantion.allowChange = true;
      }
    });
    setProposals(applications);
    console.log('app',applications);
  }, [applications, institution.id]);

  return (
    <Table className={classes.table}>
      <TableHead>
        <StyledTableRow>
          {tableHeaders.map((header) => (
            <StyledTableCell key={header.label}>{header.label}</StyledTableCell>
          ))}
        </StyledTableRow>
      </TableHead>
      <TableBody>
        {proposals.map((proposal) =>
          proposal.applicants.map((applicant, index) => (
            <TableRow
              key={`${proposal.proposalId} ${tableType} ${applicant.applicantId}`}
            >
              {index === 0 && (
                <StyledTableCell rowSpan={proposal.applicants.length}>
                  <Typography>{proposal.proposalNumber}</Typography>
                  <Typography>{proposal.proposalTitle}</Typography>
                </StyledTableCell>
              )}

              <StyledTableCell>
                <Tooltip
                  interactive
                  title={
                    <>
                      <Box>{applicant.institutionName}</Box>
                      <Box>{applicant.email}</Box>
                    </>
                  }
                >
                  <Box>{applicant.name} {applicant.isLeader && '(Leader)'}</Box>
                </Tooltip>
              </StyledTableCell>
              {index === 0 && (
                <StyledTableCell rowSpan={proposal.applicants.length}>
                  {showDate(proposal.proposalSubmissionDate)}
                </StyledTableCell>
              )}
              {index === 0 && (
                <StyledTableCell rowSpan={proposal.applicants.length}>
                  {proposal.statusCode === PRE_PROPOSAL_STATUS
                    ? "Pre Proposal"
                    : "Proposal"}
                </StyledTableCell>
              )}
              {index === 0 && tableType === "submit" && (
                <StyledTableCell rowSpan={proposal.applicants.length}>
                  <Typography>
                    {getApplicantStatus(proposal.proposalStatus)}
                  </Typography>
                </StyledTableCell>
              )}
              {index === 0 && (
                <StyledTableCell
                  style={{ maxWidth: 125 }}
                  rowSpan={proposal.applicants.length}
                >
                  <TableActions
                    canApprove={true}
                    createPDF={() =>
                      createPDF(proposal.proposalId, proposal.proposalNumber)
                    }
                    actionsType={tableType}
                    allowChange={proposal.allowChange}
                    updateProposalStatus={updateProposalStatus}
                    proposalId={proposal.proposalId}
                  />
                </StyledTableCell>
              )}
              {index === 0 && (
                <StyledTableCell rowSpan={proposal.applicants.length}>
                  <Note
                    text={proposal.noteFromRA || ""}
                    onSave={(note) =>
                      updateApplicantionNote(proposal.proposalId, note)
                    }
                  />
                </StyledTableCell>
              )}
            </TableRow>
          ))
        )}
      </TableBody>
    </Table>
  );
}
